export const CODE_APE_NFT_ABI = [
  {
    type: "function",
    name: "mintWithVoucher",
    inputs: [
      {
        name: "voucher",
        type: "tuple",
        components: [
          { name: "wallet", type: "address" },
          { name: "price", type: "uint256" },
          { name: "nonce", type: "uint256" },
          { name: "deadline", type: "uint256" },
          { name: "metadataURIHash", type: "bytes32" },
          { name: "metadataHash", type: "bytes32" },
          { name: "imageHash", type: "bytes32" },
          { name: "skillVersionHash", type: "bytes32" },
          { name: "referencePackHash", type: "bytes32" },
          { name: "chainId", type: "uint256" },
          { name: "nftContract", type: "address" }
        ]
      },
      { name: "metadataURI", type: "string" },
      { name: "signature", type: "bytes" }
    ],
    outputs: [{ name: "tokenId", type: "uint256" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "mintWithReferralVoucher",
    inputs: [
      {
        name: "voucher",
        type: "tuple",
        components: [
          { name: "wallet", type: "address" },
          { name: "referrer", type: "address" },
          { name: "price", type: "uint256" },
          { name: "nonce", type: "uint256" },
          { name: "deadline", type: "uint256" },
          { name: "metadataURIHash", type: "bytes32" },
          { name: "metadataHash", type: "bytes32" },
          { name: "imageHash", type: "bytes32" },
          { name: "skillVersionHash", type: "bytes32" },
          { name: "referencePackHash", type: "bytes32" },
          { name: "chainId", type: "uint256" },
          { name: "nftContract", type: "address" }
        ]
      },
      { name: "metadataURI", type: "string" },
      { name: "signature", type: "bytes" }
    ],
    outputs: [{ name: "tokenId", type: "uint256" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "mintManyWithReferralVouchers",
    inputs: [
      {
        name: "vouchers",
        type: "tuple[]",
        components: [
          { name: "wallet", type: "address" },
          { name: "referrer", type: "address" },
          { name: "price", type: "uint256" },
          { name: "nonce", type: "uint256" },
          { name: "deadline", type: "uint256" },
          { name: "metadataURIHash", type: "bytes32" },
          { name: "metadataHash", type: "bytes32" },
          { name: "imageHash", type: "bytes32" },
          { name: "skillVersionHash", type: "bytes32" },
          { name: "referencePackHash", type: "bytes32" },
          { name: "chainId", type: "uint256" },
          { name: "nftContract", type: "address" }
        ]
      },
      { name: "metadataURIs", type: "string[]" },
      { name: "signatures", type: "bytes[]" }
    ],
    outputs: [{ name: "tokenIds", type: "uint256[]" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "mintManyWithVouchers",
    inputs: [
      {
        name: "vouchers",
        type: "tuple[]",
        components: [
          { name: "wallet", type: "address" },
          { name: "price", type: "uint256" },
          { name: "nonce", type: "uint256" },
          { name: "deadline", type: "uint256" },
          { name: "metadataURIHash", type: "bytes32" },
          { name: "metadataHash", type: "bytes32" },
          { name: "imageHash", type: "bytes32" },
          { name: "skillVersionHash", type: "bytes32" },
          { name: "referencePackHash", type: "bytes32" },
          { name: "chainId", type: "uint256" },
          { name: "nftContract", type: "address" }
        ]
      },
      { name: "metadataURIs", type: "string[]" },
      { name: "signatures", type: "bytes[]" }
    ],
    outputs: [{ name: "tokenIds", type: "uint256[]" }],
    stateMutability: "payable"
  }
] as const;

export const REFERRAL_REWARD_VAULT_ABI = [
  {
    type: "function",
    name: "claimableReferralEth",
    inputs: [{ name: "referrer", type: "address" }],
    outputs: [{ name: "amount", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "claimReferralRewards",
    inputs: [],
    outputs: [{ name: "amount", type: "uint256" }],
    stateMutability: "nonpayable"
  }
] as const;

export const CLAIM_VAULT_ABI = [
  {
    type: "function",
    name: "poolsActivated",
    inputs: [],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "previewClaim",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [
      { name: "baseAmount", type: "uint256" },
      { name: "bonusAmount", type: "uint256" },
      { name: "totalAmount", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "burnToClaim",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [
      { name: "baseAmount", type: "uint256" },
      { name: "bonusAmount", type: "uint256" },
      { name: "ethFeeAmount", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  }
] as const;

export const CODE_APE_HOOK_ABI = [
  {
    type: "function",
    name: "claimWethFees",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{ name: "wethFeeAmount", type: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "claimEthFeesAsNative",
    inputs: [
      { name: "tokenId", type: "uint256" },
      { name: "recipient", type: "address" }
    ],
    outputs: [{ name: "ethFeeAmount", type: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pendingWethFees",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{ name: "wethFeeAmount", type: "uint256" }],
    stateMutability: "view"
  }
] as const;

export const LP_COMMUNITY_VAULT_ABI = [
  {
    type: "function",
    name: "sourceLpTokenId",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "uncxLockId",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "unlockTime",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "remainingLiquidity",
    inputs: [],
    outputs: [{ name: "", type: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "eligibleUnclaimedCount",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "uncxReleased",
    inputs: [],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "lpClaimed",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "lpForfeited",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "claimLpPositionFor",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [
      { name: "newLpTokenId", type: "uint256" },
      { name: "liquidityShare", type: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "releaseFromUncx",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  }
] as const;

export interface NormalizedMintVoucher {
  wallet: `0x${string}`;
  price: bigint;
  nonce: bigint;
  deadline: bigint;
  metadataURIHash: `0x${string}`;
  metadataHash: `0x${string}`;
  imageHash: `0x${string}`;
  skillVersionHash: `0x${string}`;
  referencePackHash: `0x${string}`;
  chainId: bigint;
  nftContract: `0x${string}`;
  referrer?: `0x${string}`;
}

function requireHex(value: unknown, field: string): `0x${string}` {
  if (typeof value !== "string" || !value.startsWith("0x")) {
    throw new Error(`voucher.${field} must be a 0x-prefixed hex string`);
  }
  return value as `0x${string}`;
}

function requireBigInt(value: unknown, field: string): bigint {
  try {
    return BigInt(String(value));
  } catch {
    throw new Error(`voucher.${field} must be bigint-compatible`);
  }
}

export function normalizeMintVoucher(voucher: Record<string, unknown>): NormalizedMintVoucher {
  return {
    wallet: requireHex(voucher.wallet, "wallet"),
    price: requireBigInt(voucher.price, "price"),
    nonce: requireBigInt(voucher.nonce, "nonce"),
    deadline: requireBigInt(voucher.deadline, "deadline"),
    metadataURIHash: requireHex(voucher.metadataURIHash, "metadataURIHash"),
    metadataHash: requireHex(voucher.metadataHash, "metadataHash"),
    imageHash: requireHex(voucher.imageHash, "imageHash"),
    skillVersionHash: requireHex(voucher.skillVersionHash, "skillVersionHash"),
    referencePackHash: requireHex(voucher.referencePackHash, "referencePackHash"),
    chainId: requireBigInt(voucher.chainId, "chainId"),
    nftContract: requireHex(voucher.nftContract, "nftContract"),
    ...(voucher.referrer ? { referrer: requireHex(voucher.referrer, "referrer") } : {})
  };
}
